import React, { useState, useContext, useEffect, useCallback, useRef } from "react";
import { UserContext } from "../../UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import { SESSION_EXPIRED_MESSAGE } from "@stocai/api";
import OtpModal from "./components/OtpModal";
import GoogleForm from "./components/GoogleForm";
import padma from "../../assets/padma.jpeg";
import turtle1 from "../../assets/aWiseTurtle.webp";
import turtle2 from "../../assets/aStudiusTurtle.webp";
import turtle3 from "../../assets/Coach4.jpg";
import {
  // FaUser,
  // FaPlus,
  FaExclamationCircle,
  // FaEnvelope,
  // FaLock,
} from "react-icons/fa";
import { FiArrowLeft } from "react-icons/fi";
// import backgroundImage from "../../assets/background8.jpeg";
import background_video from "../../assets/blue-sky-full-clouds.png";
// import { FaGoogle, FaFacebook, FaApple } from "react-icons/fa";
import { usePostHog } from "posthog-js/react";
import toast from "react-hot-toast";
// import { setUserCookie, setLogoutSignal } from "../../utils";
import { setUserCookie, deleteUserCookie, setLogoutSignal } from "../../utils";

const AuthForm = () => {
  const posthog = usePostHog();
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [formDataSignup, setFormDataSignup] = useState({
    fullName: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  });
  const [formDataSignin, setFormDataSignin] = useState({
    email: "",
    password: "",
  });
  const [formDataForgotpassword, setFormDataForgotpassword] = useState({
    email: "",
    password: "",
  });
  // const isSignup = !isLogin
  //   ? "deleteTemporaryUser"
  //   : "deleteTemporaryUserpassword";
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  // Disable form after OTP request
  const [disableForm, setDisableForm] = useState(false); // eslint-disable-line no-unused-vars
  // State to hold OTP
  const [otp, setOtp] = useState(""); // eslint-disable-line no-unused-vars
  const { user, setUser } = useContext(UserContext); // eslint-disable-line no-unused-vars
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
  // const [selectedImage, setSelectedImage] = useState(null);
  // const [selectedStockImage, setSelectedStockImage] = useState("");
  // const [showImages, setShowImages] = useState(false);
  const stockImages = [padma, turtle1, turtle2, turtle3]; // eslint-disable-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const submitInFlightRef = useRef(false);
  const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  const [paymentVerificationError, setPaymentVerificationError] = useState("");
  const [paymentVerificationSuccess, setPaymentVerificationSuccess] =
    useState(false);
  const [isPaymentSignup, setIsPaymentSignup] = useState(false);
  const [paymentActivationToken, setPaymentActivationToken] = useState("");
  const [deviceInfo, setDeviceInfo] = useState({
    device_type: "",
    os: "",
    browser: "",
  });
  const location = useLocation();
  const paymentSignupFlagKey = "razorpay_signup_verified";
  const paymentActivationTokenKey = "razorpay_payment_activation";
  const authParams = new URLSearchParams(location.search);
  const isPreviewUpgrade = authParams.get("preview_upgrade") === "1";
  const paymentAlreadyPaid = authParams.get("payment") === "already_paid";
  const sessionExpired = authParams.get("session") === "expired";

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authMode = params.get("auth");
    if (authMode === "login") {
      setIsLogin(true);
      setForgotPassword(false);
    } else if (authMode === "signup") {
      setIsLogin(false);
      setForgotPassword(false);
    }
  }, [location.search]);

  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const activationToken =
      fragment.get("payment_activation") ||
      sessionStorage.getItem(paymentActivationTokenKey);
    if (!activationToken) return;

    sessionStorage.setItem(paymentActivationTokenKey, activationToken);
    if (window.location.hash) {
      window.history.replaceState(
        window.history.state,
        "",
        `${window.location.pathname}${window.location.search}`
      );
    }

    let cancelled = false;
    const inspectActivation = async () => {
      setIsVerifyingPayment(true);
      setPaymentVerificationError("");
      try {
        const response = await fetch(`${apiBaseURL}/payments/activation/inspect`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ activation_token: activationToken }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.detail || "This account activation link is invalid or expired.");
        }
        if (cancelled) return;

        const name = (data.name || "").trim();
        const nameParts = name.split(" ");
        setPaymentActivationToken(activationToken);
        setIsPaymentSignup(true);
        setPaymentVerificationSuccess(true);
        setFormDataSignup((previous) => ({
          ...previous,
          fullName: name || previous.fullName,
          email: data.email || previous.email,
          firstName: nameParts[0] || previous.firstName,
          lastName: nameParts.slice(1).join(" ") || previous.lastName,
        }));
        setIsLogin(false);
        setForgotPassword(false);
      } catch (error) {
        if (!cancelled) {
          sessionStorage.removeItem(paymentActivationTokenKey);
          setPaymentVerificationError(
            error?.message || "This account activation link is invalid or expired."
          );
        }
      } finally {
        if (!cancelled) setIsVerifyingPayment(false);
      }
    };

    inspectActivation();
    return () => {
      cancelled = true;
    };
  }, [apiBaseURL]);

  useEffect(() => {
    const statePrefill = location.state?.prefill;
    let storedPrefill = null;

    if (!statePrefill) {
      try {
        storedPrefill = JSON.parse(
          sessionStorage.getItem("razorpay_signup_prefill") || "null"
        );
      } catch {
        storedPrefill = null;
      }
    }

    let redirectPrefill = null;
    if (!statePrefill && !storedPrefill) {
      const decodeOnce = (value) => {
        try {
          return decodeURIComponent(value);
        } catch {
          return value;
        }
      };
      const params = new URLSearchParams(location.search);
      const redirectParam = params.get("redirect");
      if (redirectParam) {
        const decodedRedirect = decodeOnce(redirectParam);
        const queryPart = decodedRedirect.includes("?")
          ? decodedRedirect.split("?").slice(1).join("?")
          : "";
        const redirectParams = new URLSearchParams(queryPart);
        const rawEmail = redirectParams.get("email");
        const rawName = redirectParams.get("name");
        const email = rawEmail ? decodeOnce(decodeOnce(rawEmail)) : "";
        const name =
          rawName && rawName !== "-" ? decodeOnce(decodeOnce(rawName)) : "";
        if (email || name) {
          redirectPrefill = { email, name };
        }
      }
    }

    if (isPreviewUpgrade) {
      setIsPaymentSignup(false);
      return;
    }

    const prefill = statePrefill || storedPrefill || redirectPrefill;
    if (!prefill) {
      return;
    }
    const paymentVerified =
      sessionStorage.getItem(paymentSignupFlagKey) === "true";
    setIsPaymentSignup(paymentVerified);

    const name = (prefill.name || "").trim();
    const nameParts = name.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    setFormDataSignup((prev) => ({
      ...prev,
      fullName: name || prev.fullName,
      email: prefill.email || prev.email,
      firstName: firstName || prev.firstName,
      lastName: lastName || prev.lastName,
    }));
    setIsLogin(false);
    setForgotPassword(false);
    sessionStorage.removeItem("razorpay_signup_prefill");
  }, [isPreviewUpgrade, location.search, location.state]);

  useEffect(() => {
    if (!paymentVerificationSuccess) {
      return;
    }

    if (isPreviewUpgrade) {
      return;
    }

    let storedPrefill = null;
    try {
      storedPrefill = JSON.parse(
        sessionStorage.getItem("razorpay_signup_prefill") || "null"
      );
    } catch {
      storedPrefill = null;
    }

    if (!storedPrefill) {
      return;
    }

    const name = (storedPrefill.name || "").trim();
    const nameParts = name.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    setFormDataSignup((prev) => ({
      ...prev,
      fullName: name || prev.fullName,
      email: storedPrefill.email || prev.email,
      firstName: firstName || prev.firstName,
      lastName: lastName || prev.lastName,
    }));
    setIsLogin(false);
    setForgotPassword(false);
    sessionStorage.removeItem("razorpay_signup_prefill");
  }, [isPreviewUpgrade, paymentVerificationSuccess]);

  const detectDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for mobile or tablet user agents
    if (/android/i.test(userAgent)) {
      return "Mobile";
    }
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "Mobile";
    }

    // Default to Desktop for others
    return "Desktop";
  };

  const detectOperatingSystem = () => {
    const platform = navigator.platform || "Unknown OS";
    const userAgent = navigator.userAgent;

    if (/Win/.test(platform)) {
      return "Windows";
    } else if (/Mac/.test(platform)) {
      return "macOS";
    } else if (/Linux/.test(platform)) {
      return "Linux";
    } else if (/Android/.test(userAgent)) {
      return "Android";
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      return "iOS";
    }

    return "Unknown OS";
  };

  const detectBrowser = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf("Firefox") > -1) {
      return "Firefox";
    } else if (userAgent.indexOf("SamsungBrowser") > -1) {
      return "Samsung Internet";
    } else if (
      userAgent.indexOf("Opera") > -1 ||
      userAgent.indexOf("OPR") > -1
    ) {
      return "Opera";
    } else if (userAgent.indexOf("Trident") > -1) {
      return "Internet Explorer";
    } else if (userAgent.indexOf("Edge") > -1) {
      return "Microsoft Edge";
    } else if (userAgent.indexOf("Chrome") > -1) {
      return "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    }

    return "Unknown Browser";
  };

  useEffect(() => {
    const deviceType = detectDeviceType();
    const os = detectOperatingSystem();
    const browser = detectBrowser();

    setDeviceInfo({
      device_type: deviceType,
      os: os,
      browser: browser,
    });
  }, []);

  useEffect(() => {
    // console.log("useEffect ran");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const hasPaymentParams = Boolean(
    new URLSearchParams(location.search).get("razorpay_payment_id") ||
      new URLSearchParams(location.search).get("razorpay_signature")
  );

  const clearUserSession = useCallback(() => {
    setLogoutSignal();
    setUser({ user_id: "", firstName: "", lastName: "" });
    localStorage.removeItem("user");
    deleteUserCookie();
  }, [setUser]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isPreviewUpgradeReturn = params.get("preview_upgrade") === "1";
    const payload = {
      payment_link_id: params.get("razorpay_payment_link_id"),
      payment_link_reference_id: params.get(
        "razorpay_payment_link_reference_id"
      ),
      payment_link_status: params.get("razorpay_payment_link_status"),
      payment_id: params.get("razorpay_payment_id"),
      signature: params.get("razorpay_signature"),
    };

    if (!payload.payment_id || !payload.signature) {
      return;
    }

    let isCancelled = false;
    const verifyPayment = async () => {
      setIsVerifyingPayment(true);
      setPaymentVerificationError("");
      setPaymentVerificationSuccess(false);

      try {
        const res = await fetch(`${apiBaseURL}/payments/razorpay/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json().catch(() => ({}));
        console.log("Razorpay verify response:", data);

        if (!res.ok) {
          throw new Error(
            data.detail || "Payment verification failed. Please contact support."
          );
        }

        if (data.verified) {
          if (!isCancelled) {
            setPaymentVerificationSuccess(true);

            if (isPreviewUpgradeReturn) {
              clearUserSession();
              toast.success(
                "Payment verified. Please log in again to unlock full access."
              );
              setIsLogin(true);
              setForgotPassword(false);
              navigate("/signUp?auth=login&preview_upgrade=1", {
                replace: true,
              });
              return;
            }

            sessionStorage.setItem(paymentSignupFlagKey, "true");
            const prefillEmail =
              data.email || data.user?.email || data.customer?.email || "";
            const prefillName =
              data.name ||
              data.user?.name ||
              data.customer?.name ||
              "";
            const name = prefillName.trim();
            const nameParts = name.split(" ");
            const firstName = nameParts[0] || "";
            const lastName = nameParts.slice(1).join(" ") || "";
            const prefill = { name: prefillName, email: prefillEmail };
            sessionStorage.setItem(
              "razorpay_signup_prefill",
              JSON.stringify(prefill)
            );
            setFormDataSignup((prev) => ({
              ...prev,
              fullName: name || prev.fullName,
              email: prefillEmail || prev.email,
              firstName: firstName || prev.firstName,
              lastName: lastName || prev.lastName,
            }));
            setIsLogin(false);
            setForgotPassword(false);
            navigate("/signUp", { replace: true, state: { prefill } });
          }
          return;
        }

        throw new Error(
          data.detail || "Payment verification failed. Please contact support."
        );
      } catch (error) {
        if (!isCancelled) {
          setPaymentVerificationError(
            error?.message ||
              "Payment verification failed. Please contact support."
          );
        }
      } finally {
        if (!isCancelled) {
          setIsVerifyingPayment(false);
        }
      }
    };

    verifyPayment();

    return () => {
      isCancelled = true;
    };
  }, [apiBaseURL, clearUserSession, location.search, navigate]);

  const handleSendDeviceInfo = async (data) => {
    const userDeviceInfo = {
      user_id: data,
      device_type: deviceInfo.device_type,
      os: deviceInfo.os,
      browser: deviceInfo.browser,
    };
    // Send this data to the backend
    try {
      const response = await fetch(`${apiBaseURL}/DeviceInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userDeviceInfo),
      });

      const data = await response.json();
      console.log("Device info sent successfully:", data);
    } catch (error) {
      console.error("Error sending device info:", error);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    return password.length >= 8; // At least 8 characters
  };

  const handleChangeSignup = (e) => {
    const { name, value } = e.target;

    if (name === "fullName") {
      const nameParts = value.trim().split(" ");
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";
      setFormDataSignup({
        ...formDataSignup,
        fullName: value,
        firstName,
        lastName,
      });
    } else {
      setFormDataSignup({ ...formDataSignup, [name]: value });
    }

  };

  const handleChangeSignin = (e) => {
    setFormDataSignin({ ...formDataSignin, [e.target.name]: e.target.value });
  };

  const handleForgotPassword = (e) => {
    setFormDataForgotpassword({
      ...formDataForgotpassword,
      [e.target.name]: e.target.value,
    });
  };

  // Corrected sendOtpForSignup function
  const sendOtpForSignup = async () => {
    handleOtpCancel();
    setLoading(true);
    // Clear previous errors

    try {
      const res = await fetch(`${apiBaseURL}/signUp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDataSignup),
      });

      const result = await res.json();

      if (res.ok) {
        console.log("OTP sent successfully");
        toast.success("OTP has been sent to your email.");
        setOtpModalOpen(true);
        setDisableForm(true); // Should be true to disable form after OTP request
      } else {
        toast.error(result.detail || "An error occurred");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  // Corrected sendOtpForPasswordReset function
  const sendOtpForPasswordReset = async () => {
    console.log(formDataForgotpassword);
    handleOtpCancel();
    setLoading(true);
    // Clear previous errors

    try {
      const res = await fetch(`${apiBaseURL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDataForgotpassword),
      });

      const result = await res.json();

      if (res.ok) {
        console.log("OTP sent successfully for password reset");
        toast.success("OTP has been sent to your email for password reset.");
        setOtpModalOpen(true);
        setDisableForm(true); // Should be true to disable form after OTP request
      } else {
        toast.error(result.detail || "An error occurred");
      }
    } catch (error) {
      console.error("Error sending OTP for password reset:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  // Corrected handleSubmit function with better error handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitInFlightRef.current) return;
    submitInFlightRef.current = true;
    setLoading(true);
    // Clear previous errors

    try {
      if (!isLogin) {
        // Sign Up Logic
        if (!validateEmail(formDataSignup.email)) {
          toast.error("Please enter a valid email address.");
          return;
        }

        if (!validatePassword(formDataSignup.password)) {
          toast.error("Password must be at least 8 characters long.");
          return;
        }

        if (!formDataSignup.firstName.trim()) {
          toast.error("Please enter your name.");
          return;
        }

        if (isPaymentSignup) {
          await createAccountAfterPayment();
        } else {
          await sendOtpForSignup();
        }
      } else if (forgotPassword) {
        // Password Reset Logic
        if (!validateEmail(formDataForgotpassword.email)) {
          toast.error("Please enter a valid email address.");
          return;
        }

        if (!validatePassword(formDataForgotpassword.password)) {
          toast.error("Password must be at least 8 characters long.");
          return;
        }

        await sendOtpForPasswordReset();
      } else {
        // Handle Login Logic
        if (!validateEmail(formDataSignin.email)) {
          toast.error("Please enter a valid email address.");
          return;
        }

        if (!formDataSignin.password.trim()) {
          toast.error("Please enter your password.");
          return;
        }

        console.log("login is about to happen");

        const res = await fetch(`${apiBaseURL}/logIn`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formDataSignin),
        });

        const result = await res.json();
        console.log(result);

        if (res.ok) {
          toast.success("Login successful");
          setUser(result);
          localStorage.setItem("user", JSON.stringify(result));
          setUserCookie(result);
          if (isPreviewUpgrade) {
            sessionStorage.setItem("preview_upgrade_complete", "true");
          }

          // Check for temp_user_id and link if present
          const tempUserId = localStorage.getItem("temp_user_id");
          console.log("Temp User", { tempUserId });

          if (tempUserId) {
            try {
              await fetch(`${apiBaseURL}/quiz/link-user`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  temp_user_id: tempUserId,
                  user_id: result.user_id || result.userid || result.id,
                }),
              });
              localStorage.removeItem("temp_user_id");
              navigate("/quiz/result", { replace: true });
            } catch (err) {
              console.error("Failed to link quiz to user:", err);
              navigate("/", { replace: true });
            }
          } else {
            navigate("/", { replace: true }); // RoleBasedLanding decides where to go
          }
          console.log(
            "this is working",
            result.user_id,
            result.firstName + result.lastName
          );

          posthog.identify(formDataSignin.email);
          posthog.people.set({
            name: result.firstName + result.lastName,
            userID: result.user_id,
            email: formDataSignin.email,
          });
          console.log("PostHog identify + people.set called ✅");

          handleSendDeviceInfo(result.user_id);
        } else {
          const detailMessage =
            result.detail || "Login failed. Please check your credentials.";
          toast.error(detailMessage);
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      submitInFlightRef.current = false;
      setLoading(false);
    }
  };

  // Corrected handleOtpSubmit function
  const handleOtpSubmit = async (otp) => {
    setOtp(otp);
    setLoading(true);
    let shouldCloseOnError = false;

    try {
      if (forgotPassword) {
        // Password reset OTP verification
        const res = await fetch(`${apiBaseURL}/verify-reset-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: formDataForgotpassword.email, otp }),
        });

        const result = await res.json();

        if (res.ok) {
          toast.success("Password reset successful. Please log in.");
          setOtpModalOpen(false);
          setDisableForm(false);
          setIsLogin(true);
          setForgotPassword(false);
          setFormDataForgotpassword({
            email: "",
            password: "",
          });
        } else {
          toast.error(result.detail || "Invalid OTP. Please try again.");
          shouldCloseOnError = true;
        }
      } else {
        // Signup OTP verification
        const res = await fetch(`${apiBaseURL}/verifyOtp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: formDataSignup.email, otp }),
        });

        const result = await res.json();

        if (res.ok) {
          toast.success("Registration successful. You can log in now.");
          setOtpModalOpen(false);
          setIsLogin(true);
          setDisableForm(false);
          // Clear signup form
          setFormDataSignup({
            email: "",
            password: "",
            firstName: "",
            lastName: "",
          });
        } else {
          toast.error(result.detail || "Invalid OTP. Please try again.");
          shouldCloseOnError = true;
        }
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Something went wrong. Please try again later.");
      shouldCloseOnError = true;
    } finally {
      setLoading(false);
      if (shouldCloseOnError) {
        setOtpModalOpen(false); // Close modal on error
      }
    }
  };

  const createAccountAfterPayment = async () => {
    setLoading(true);

    try {
      const activationToken =
        paymentActivationToken ||
        sessionStorage.getItem(paymentActivationTokenKey);
      const res = await fetch(
        activationToken
          ? `${apiBaseURL}/payments/activate-account`
          : `${apiBaseURL}/signUp`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(
          activationToken
            ? {
                activation_token: activationToken,
                password: formDataSignup.password,
              }
            : {
                ...formDataSignup,
                skip_otp: true,
              }
        ),
      });

      const result = await res.json();

      if (res.ok) {
        toast.success("Account created. You're now logged in.");
        setUser(result);
        localStorage.setItem("user", JSON.stringify(result));
        setUserCookie(result);

        const email = result.email || formDataSignup.email;
        const name =
          `${result.firstName || ""}${result.lastName || ""}`.trim() ||
          `${formDataSignup.firstName || ""}${formDataSignup.lastName || ""}`.trim();

        posthog.identify(email);
        posthog.people.set({
          name,
          userID: result.user_id,
          email,
        });

        // Check for temp_user_id and link if present
        const tempUserId = localStorage.getItem("temp_user_id");
        if (tempUserId) {
          try {
            await fetch(`${apiBaseURL}/quiz/link-user`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                temp_user_id: tempUserId,
                user_id: result.user_id || result.userid || result.id,
              }),
            });
            localStorage.removeItem("temp_user_id");
            navigate("/quiz/result", { replace: true });
          } catch (err) {
            console.error("Failed to link quiz to user:", err);
            navigate("/", { replace: true });
          }
        } else {
          navigate("/", { replace: true }); // RoleBasedLanding decides where to go
        }

        setForgotPassword(false);
        setOtpModalOpen(false);
        setDisableForm(false);
        setFormDataSignup({
          fullName: "",
          email: "",
          password: "",
          firstName: "",
          lastName: "",
        });
        setIsPaymentSignup(false);
        setPaymentActivationToken("");
        sessionStorage.removeItem(paymentSignupFlagKey);
        sessionStorage.removeItem(paymentActivationTokenKey);
      } else {
        toast.error(result.detail || "An error occurred");
      }
    } catch (error) {
      console.error("Error creating account after payment:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Corrected handleOtpCancel function
  const handleOtpCancel = async () => {
    try {
      const email = !isLogin
        ? formDataSignup.email
        : formDataForgotpassword.email;
      const endpoint = !isLogin
        ? "deleteTemporaryUser"
        : "deleteTemporaryUserpassword";

      const res = await fetch(`${apiBaseURL}/${endpoint}?email=${email}`, {
        method: "DELETE",
      });

      if (res.ok) {
        setOtpModalOpen(false);
        setDisableForm(false);
      } else {
        const result = await res.json();
        toast.error(
          result.detail || "An error occurred while canceling OTP"
        );
      }
    } catch (error) {
      console.error("Error deleting temporary user data:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const googleFirebaseLogin = async (result) => {
    console.log("this is from the result", result);
    setLoading(false);
    toast.success("Login successful");
    setUser(result);
    posthog.identify(result.email);
    posthog.people.set({
      name: result.firstName + result.lastName,
      userID: result.user_id,
      email: result.email,
    });
    console.log("PostHog identify + people.set called ✅");

    localStorage.setItem("user", JSON.stringify(result));
    setUserCookie(result);

    const tempUserId = localStorage.getItem("temp_user_id");
    console.log("Temp User", { tempUserId });

    try {
      if (tempUserId) {
        await fetch(`${apiBaseURL}/quiz/link-user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            temp_user_id: tempUserId,
            user_id: result.user_id || result.userid || result.id,
          }),
        });

        // ⚠️ Do NOT remove temp_user_id here anymore
        // It will be removed in the final submission flow
      }
      navigate("/", { replace: true });
    } catch (err) {
      console.error("Failed to link quiz to user:", err);
      navigate("/", { replace: true });
    }

    handleSendDeviceInfo(result.user_id);
  };

  return (
    <div className="font-gotham flex items-center justify-center min-h-screen w-full p-4 md:p-10 relative">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden z-0">
        <img
          src={background_video}
          alt="Blue sky full clouds"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form Container */}
      <div className="flex w-full items-center justify-center relative z-10">
        <div
          className="
    relative flex flex-col items-center justify-center
    w-full max-w-[560px]
    min-h-[560px] sm:min-h-[620px]
    px-6 sm:px-10 py-10 sm:py-12
    rounded-[32px] sm:rounded-[49px]
    bg-white/[0.05]  /* More opaque white for that frosted feel */
    backdrop-blur-[52px]
    border-[2px] border-white/10
    shadow-[inset_0_0_44px_rgba(166,166,166,0.25),0_8px_32px_rgba(31,38,135,0.15)]
    overflow-hidden
  "
        >
          {/* 🔹 Decorative gradient overlay */}
          <div
            className="
        absolute inset-0 rounded-[49px] pointer-events-none
        bg-gradient-to-br from-white/40 via-white/10 to-white/10
        [mask-image:linear-gradient(white,white)]
        [mask-composite:exclude] [-webkit-mask-composite:xor]
      "
          ></div>
          <div className="relative z-10 flex flex-col items-center w-full">
            {/* Headings */}
            {isLogin ? (
              forgotPassword ? (
                <>
                  <h3
                    className="font-gotham font-normal text-[16px] leading-[150%]
                   text-black text-center mb-1"
                  >
                    Don’t worry, we’ll handle it
                  </h3>
                  <h2
                    className="font-gotham font-medium text-[24px] leading-[140%]
                   text-black text-center mb-4"
                  >
                    Reset your password
                  </h2>
                </>
              ) : (
                <>
                  <h3
                    className="font-gotham font-normal text-[16px] leading-[150%]
                   text-black text-center mb-1"
                  >
                    Welcome Back
                  </h3>
                  <h2
                    className="font-gotham font-medium text-[24px] leading-[140%]
                   text-black text-center mb-2"
                  >
                    Get back to it
                  </h2>
                </>
              )
            ) : (
              <>
                <h2
                  className="font-gotham font-medium text-[32px] leading-[140%]
             text-black text-center tracking-[0] mb-3"
                >
                  Create New Account
                </h2>
                <h3
                  className="font-gotham font-normal text-[16px] leading-[150%]
                 text-black text-center mb-1"
                >
                  Enter your details
                </h3>
              </>
            )}

            {/* Alerts */}
            {sessionExpired && (
              <div className="mb-4 flex w-full max-w-[480px] items-center rounded-lg bg-red-500/10 px-4 py-2 text-sm text-red-700">
                <FaExclamationCircle className="mr-2" />
                {SESSION_EXPIRED_MESSAGE}
              </div>
            )}

            {paymentAlreadyPaid && (
              <div className="mb-4 flex w-full max-w-[480px] items-center rounded-lg bg-emerald-500/10 px-4 py-3 text-sm text-emerald-800">
                Your payment is already complete. Log in to continue, or use Forgot Password if you have not set a password yet.
              </div>
            )}

            {hasPaymentParams && !paymentVerificationSuccess && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                <div className="flex flex-col items-center gap-4 rounded-2xl bg-white/90 px-8 py-6 text-center shadow-xl">
                  <div className="text-lg font-semibold text-gray-900">
                    Verifying payment...
                  </div>
                  {isVerifyingPayment && (
                    <span className="h-10 w-10 rounded-full border-4 border-gray-400 border-t-transparent animate-spin"></span>
                  )}
                  {paymentVerificationError && (
                    <div className="flex items-center bg-red-500/10 text-red-700 px-4 py-2 rounded-lg text-sm">
                      <FaExclamationCircle className="mr-2" />{" "}
                      {paymentVerificationError}
                    </div>
                  )}
                </div>
              </div>
            )}

            {(!hasPaymentParams || paymentVerificationSuccess) && (
              <form
                onSubmit={handleSubmit}
                className="w-full flex flex-col gap-5 items-center"
              >
                {!isLogin ? (
                  <>
                    {/* Name */}
                    <div
                      className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                    >
                      <input
                        type="text"
                        name="fullName"
                        placeholder="Name *"
                        value={formDataSignup.fullName}
                        onChange={handleChangeSignup}
                        required
                        className="
                                  w-full h-full px-4
                                  bg-transparent
                                  text-black placeholder-black
                                  text-[16px] leading-[150%]
                                  font-gotham font-normal
                                  rounded-[20px]
                                  focus:outline-none
                                "
                      />
                    </div>

                    {/* Email */}
                    <div
                      className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                    >
                      <input
                        type="email"
                        name="email"
                        placeholder="Email *"
                        value={formDataSignup.email}
                        onChange={handleChangeSignup}
                        required
                        className="
                                  w-full h-full px-4
                                  bg-transparent
                                  text-black placeholder-black
                                  text-[16px] leading-[150%]
                                  font-gotham font-normal
                                  rounded-[20px]
                                  focus:outline-none
                                "
                      />
                    </div>

                    {/* Password */}
                    <div
                      className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                    >
                      <input
                        type="password"
                        name="password"
                        placeholder="Password *"
                        value={formDataSignup.password}
                        onChange={handleChangeSignup}
                        required
                        className="
                                  w-full h-full px-4
                                  bg-transparent
                                  text-black placeholder-black
                                  text-[16px] leading-[150%]
                                  font-gotham font-normal
                                  rounded-[20px]
                                  focus:outline-none
                                "
                      />
                    </div>

                    {/* Signup Button */}
                    <button
                      type="submit"
                      disabled={loading}
                      className="
                                w-full max-w-[480px] h-[56px] sm:h-[58px] mt-3
                                bg-[#000000] text-white
                                font-gotham font-medium text-[16px] leading-[150%]
                                rounded-[20px]
                                flex items-center justify-center
                                shadow-[0_4px_12px_rgba(0,0,0,0.15)]
                                hover:bg-[#111111] active:scale-[0.99]
                                transition-all duration-300
                              "
                    >
                      {loading ? (
                        <span className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                      ) : (
                        "Create Account"
                      )}
                    </button>
                  </>
                ) : (
                  <>
                    {forgotPassword ? (
                      <>
                        {/* Reset Email */}
                        <div
                          className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                        >
                          <input
                            type="email"
                            name="email"
                            placeholder="Email *"
                            value={formDataForgotpassword.email}
                            onChange={handleForgotPassword}
                            required
                            className="
                                      w-full h-full px-4
                                      bg-transparent
                                      text-black placeholder-black
                                      text-[16px] leading-[150%]
                                      font-gotham font-normal
                                      rounded-[20px]
                                      focus:outline-none
                                    "
                          />
                        </div>

                        {/* Reset Password */}
                        <div
                          className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                        >
                          <input
                            type="password"
                            name="password"
                            placeholder="New password *"
                            value={formDataForgotpassword.password}
                            onChange={handleForgotPassword}
                            required
                            className="w-full h-full px-4
                                      bg-transparent
                                      text-black placeholder-black
                                      text-[16px] leading-[150%]
                                      font-gotham font-normal
                                      rounded-[20px]
                                      focus:outline-none
                                    "
                          />
                        </div>

                        <button
                          className="w-full max-w-[480px] h-[56px] sm:h-[58px] mt-3 bg-black text-white font-semibold rounded-[20px]
                       shadow-md hover:bg-gray-900 transition-all duration-300"
                          onClick={() => sendOtpForPasswordReset()}
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                          ) : (
                            "Send OTP"
                          )}
                        </button>
                      </>
                    ) : (
                      <>
                        {/* Login Email */}
                        <div
                          className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                        >
                          <input
                            type="email"
                            name="email"
                            placeholder="Email *"
                            value={formDataSignin.email}
                            onChange={handleChangeSignin}
                            required
                            className="
                            w-full h-full px-4
                            bg-transparent
                            text-black placeholder-black
                            text-[16px] leading-[150%]
                            font-gotham font-normal
                            rounded-[20px]
                            focus:outline-none
                          "
                          />
                        </div>

                        {/* Login Password */}
                        <div
                          className="relative w-full max-w-[480px] h-[56px] sm:h-[58px] rounded-[20px]
                          bg-white/5 backdrop-blur-[52px]
                          border border-white/10
                          shadow-[inset_0_0_44px_0_rgba(166,166,166,0.25)]
                          flex items-center"
                        >
                          <input
                            type="password"
                            name="password"
                            placeholder="Password *"
                            value={formDataSignin.password}
                            onChange={handleChangeSignin}
                            required
                            className="
                            w-full h-full px-4
                            bg-transparent
                            text-black placeholder-black
                            text-[16px] leading-[150%]
                            font-gotham font-normal
                            rounded-[20px]
                            focus:outline-none
                            "
                          />
                        </div>

                        <button
                          type="submit"
                          className="
                          w-full max-w-[480px] h-[56px] sm:h-[58px] mt-3
                          bg-[#000000] text-white
                          font-gotham font-medium text-[16px] leading-[150%]
                          rounded-[20px]
                          flex items-center justify-center
                          shadow-[0_4px_12px_rgba(0,0,0,0.15)]
                          hover:bg-[#111111] active:scale-[0.99]
                          transition-all duration-300
                        "
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </>
                    )}

                    {/* Forgot Password Toggle */}
                    <button
                      onClick={() => setForgotPassword(!forgotPassword)}
                      className="text-[#54b0af] hover:text-[#4a9998] text-sm font-medium w-full text-center mt-2"
                    >
                      {forgotPassword ? (
                        <span className="flex items-center justify-center">
                          <FiArrowLeft className="mr-2" /> Back to Login
                        </span>
                      ) : (
                        "Forgot Password?"
                      )}
                    </button>
                  </>
                )}
              </form>
            )}

            {/* OR Divider */}
            {!forgotPassword && (!hasPaymentParams || paymentVerificationSuccess) && (
              <div className="relative flex items-center justify-center w-full my-6">
                <div className="flex-grow border-t border-[#FFFFFF]" />
                <span
                  className="px-4 font-gotham font-normal text-[16px] leading-[150%]
                 text-[#2C2C2C] text-center"
                >
                  OR
                </span>
                <div className="flex-grow border-t border-[#FFFFFF]" />
              </div>
            )}

            {/* Google Login */}
            <div className="flex justify-center space-x-4 mt-6">
              {!forgotPassword && (
                <GoogleForm
                  onClose={googleFirebaseLogin}
                  loading={loading}
                  setLoading={setLoading}
                  onError={(message) => {
                    toast.error(
                      message ||
                        "We couldn't log you in right now. Please try again in a moment."
                    );
                  }}
                />
              )}
            </div>

            {/* Switch Auth Mode */}
            <div className="mt-6">
              <p className="text-center text-[16px] leading-[150%] font-medium text-black">
                {isLogin ? "Don’t have an account?" : "Already a member?"}{" "}
                <button
                  onClick={() => {
                    setIsLogin(!isLogin);
                    setForgotPassword(false);
                  }}
                  className="underline underline-offset-[2px] font-medium text-black hover:text-[#4a9998] transition-colors"
                >
                  {isLogin ? "Sign Up" : "Login"}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      <OtpModal
        isOpen={otpModalOpen}
        onClose={() => setOtpModalOpen(false)}
        onVerify={handleOtpSubmit}
        onCancel={handleOtpCancel}
      />
    </div>
  );
};

export default AuthForm;
